var map = {
	"./bell.svg": 260,
	"./brain.svg": 261,
	"./eye.svg": 65,
	"./eye_closed.svg": 66,
	"./file.svg": 262,
	"./icon-arrow-blue.svg": 263,
	"./icon-arrow-down.svg": 38,
	"./icon-arrow-white.svg": 264,
	"./icon-arrow.svg": 255,
	"./icon-check.svg": 265,
	"./icon-cross-grey.svg": 266,
	"./icon-cross.svg": 267,
	"./icon-wallet.svg": 268,
	"./people-group.svg": 269,
	"./read-more-arrow.svg": 270,
	"./shield.svg": 271,
	"./taggis-hub-logo.svg": 67,
	"./taggis-logo-icon.svg": 272,
	"./taggis-logo.svg": 273,
	"./target.svg": 274,
	"./tools.svg": 275,
	"./zoom-blue.svg": 276
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 259;


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg ^\.\/.*$
// module id = 259
// module chunks = 3